__turbopack_context__.v({
  "aboutheading1": "optional-module__XEnk8q__aboutheading1",
  "aboutparagraph1": "optional-module__XEnk8q__aboutparagraph1",
  "aboutparagraph2": "optional-module__XEnk8q__aboutparagraph2",
  "acheivername": "optional-module__XEnk8q__acheivername",
  "acheiverrank": "optional-module__XEnk8q__acheiverrank",
  "acheiverrank1": "optional-module__XEnk8q__acheiverrank1",
  "acheiverrankspecial": "optional-module__XEnk8q__acheiverrankspecial",
  "admincontent": "optional-module__XEnk8q__admincontent",
  "badge": "optional-module__XEnk8q__badge",
  "blinking": "optional-module__XEnk8q__blinking",
  "bodred": "optional-module__XEnk8q__bodred",
  "captcha": "optional-module__XEnk8q__captcha",
  "cardBox": "optional-module__XEnk8q__cardBox",
  "checkboxcontent": "optional-module__XEnk8q__checkboxcontent",
  "checkiconcss": "optional-module__XEnk8q__checkiconcss",
  "circleGlow": "optional-module__XEnk8q__circleGlow",
  "contactheader": "optional-module__XEnk8q__contactheader",
  "content": "optional-module__XEnk8q__content",
  "contentbg": "optional-module__XEnk8q__contentbg",
  "contl": "optional-module__XEnk8q__contl",
  "dark": "optional-module__XEnk8q__dark",
  "description": "optional-module__XEnk8q__description",
  "dot": "optional-module__XEnk8q__dot",
  "downloadicon": "optional-module__XEnk8q__downloadicon",
  "facultyborder3": "optional-module__XEnk8q__facultyborder3",
  "featureCard": "optional-module__XEnk8q__featureCard",
  "featureGrid": "optional-module__XEnk8q__featureGrid",
  "formstar": "optional-module__XEnk8q__formstar",
  "handicon": "optional-module__XEnk8q__handicon",
  "heading3d": "optional-module__XEnk8q__heading3d",
  "heroCard": "optional-module__XEnk8q__heroCard",
  "imagee": "optional-module__XEnk8q__imagee",
  "invalidCheck2": "optional-module__XEnk8q__invalidCheck2",
  "normalbutton": "optional-module__XEnk8q__normalbutton",
  "normalbutton1": "optional-module__XEnk8q__normalbutton1",
  "normalbutton2": "optional-module__XEnk8q__normalbutton2",
  "numberbold": "optional-module__XEnk8q__numberbold",
  "pagemaintitle": "optional-module__XEnk8q__pagemaintitle",
  "paybill": "optional-module__XEnk8q__paybill",
  "phoneiconcss": "optional-module__XEnk8q__phoneiconcss",
  "prebg": "optional-module__XEnk8q__prebg",
  "presbg": "optional-module__XEnk8q__presbg",
  "program": "optional-module__XEnk8q__program",
  "redunderline": "optional-module__XEnk8q__redunderline",
  "redunderlinealink": "optional-module__XEnk8q__redunderlinealink",
  "rotateGlow": "optional-module__XEnk8q__rotateGlow",
  "sectionredtitle": "optional-module__XEnk8q__sectionredtitle",
  "sectionsubtitle": "optional-module__XEnk8q__sectionsubtitle",
  "sectiontitle": "optional-module__XEnk8q__sectiontitle",
  "sectiontitle1": "optional-module__XEnk8q__sectiontitle1",
  "statCircle": "optional-module__XEnk8q__statCircle",
  "statsRow": "optional-module__XEnk8q__statsRow",
  "tablebg": "optional-module__XEnk8q__tablebg",
  "tableheading": "optional-module__XEnk8q__tableheading",
  "tablinks": "optional-module__XEnk8q__tablinks",
  "tabscrollclass": "optional-module__XEnk8q__tabscrollclass",
  "tabsection": "optional-module__XEnk8q__tabsection",
  "title": "optional-module__XEnk8q__title",
  "ulclass": "optional-module__XEnk8q__ulclass",
  "ulliclass": "optional-module__XEnk8q__ulliclass",
  "ullispan": "optional-module__XEnk8q__ullispan",
  "whatsnewkeyanimation": "optional-module__XEnk8q__whatsnewkeyanimation",
});
